var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirectboxDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "directbox-default"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 18.9596H6.66667C1.875 18.9596 1.875 16.418 1.875 14.168V13.3346C1.875 11.4763 1.875 9.3763 5.83333 9.3763C6.825 9.3763 7.19167 9.61797 7.70833 10.0013C7.73333 10.0263 7.76667 10.043 7.79167 10.0763L8.64167 10.9763C9.35833 11.7346 10.6583 11.7346 11.375 10.9763L12.225 10.0763C12.25 10.0513 12.275 10.0263 12.3083 10.0013C12.825 9.60964 13.1917 9.3763 14.1833 9.3763C18.1417 9.3763 18.1417 11.4763 18.1417 13.3346V14.168C18.125 17.3513 16.5167 18.9596 13.3333 18.9596ZM5.83333 10.6263C3.125 10.6263 3.125 11.4763 3.125 13.3346V14.168C3.125 16.4513 3.125 17.7096 6.66667 17.7096H13.3333C15.8167 17.7096 16.875 16.6513 16.875 14.168V13.3346C16.875 11.4763 16.875 10.6263 14.1667 10.6263C13.5667 10.6263 13.4417 10.7013 13.0833 10.968L12.275 11.8263C11.675 12.4596 10.8667 12.8096 10 12.8096C9.13333 12.8096 8.325 12.4596 7.725 11.8263L6.91667 10.968C6.55833 10.7013 6.43333 10.6263 5.83333 10.6263Z",
    fill: "#026C96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 10.6263C15.4917 10.6263 15.2083 10.343 15.2083 10.0013V5.0013C15.2083 3.14297 15.2083 2.29297 12.5 2.29297H7.5C4.79167 2.29297 4.79167 3.14297 4.79167 5.0013V10.0013C4.79167 10.343 4.50833 10.6263 4.16667 10.6263C3.825 10.6263 3.54167 10.343 3.54167 10.0013V5.0013C3.54167 3.14297 3.54167 1.04297 7.5 1.04297H12.5C16.4583 1.04297 16.4583 3.14297 16.4583 5.0013V10.0013C16.4583 10.343 16.175 10.6263 15.8333 10.6263Z",
    fill: "#026C96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectboxDefault);
export default __webpack_public_path__ + "static/media/directbox-default.0584c0eea836ed8330371cf2b86c0f18.svg";
export { ForwardRef as ReactComponent };